"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initTableWithDivider = void 0;
var api_1 = require("../api");
var alertifyjs = require("alertifyjs");
var playlistId = null;
var dividerColors = ['yellow', 'violet', 'green', 'pink', 'orange'];
function initTableWithDivider(table) {
    return __awaiter(this, void 0, void 0, function () {
        function mousedown(e) {
            if (e.button === 0 && e.target instanceof HTMLElement) {
                if (e.target.parentElement.classList.contains('rows-divider')) {
                    var target = e.target.parentElement;
                    target.classList.add('rows-divider__moving');
                    document.addEventListener('mousemove', mousemove);
                    document.addEventListener('mouseup', mouseup, { once: true });
                }
            }
        }
        function mousemove(e) {
            if (e.target instanceof HTMLElement) {
                var isTargetOnTbody = Boolean(e.target.closest('tbody'));
                var isTargetOnDivider = Boolean(e.target.closest('.rows-divider'));
                if (isTargetOnTbody) {
                    var tbody = table.querySelector('tbody');
                    var divider = tbody.querySelector('.rows-divider.rows-divider__moving');
                    var currentRow = e.target.closest('tr');
                    var rowHeight = currentRow.clientHeight;
                    var currentRowPageY = currentRow.getBoundingClientRect().top + window.pageYOffset;
                    var eCurrentRowY = e.pageY - currentRowPageY;
                    tbody.insertBefore(divider, (eCurrentRowY < rowHeight / 2) ? currentRow : currentRow.nextElementSibling);
                }
            }
            e.preventDefault();
        }
        function mouseup() {
            return __awaiter(this, void 0, void 0, function () {
                var dividerRow;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            document.removeEventListener('mousemove', mousemove);
                            dividerRow = document.querySelector('.rows-divider.rows-divider__moving');
                            dividerRow === null || dividerRow === void 0 ? void 0 : dividerRow.classList.remove('rows-divider__moving');
                            if (!dividerRow.dataset.hasOwnProperty('id')) return [3 /*break*/, 2];
                            return [4 /*yield*/, updateDividerPosition(dividerRow)];
                        case 1:
                            _a.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, createDivider(dividerRow)];
                        case 3:
                            _a.sent();
                            _a.label = 4;
                        case 4: return [2 /*return*/];
                    }
                });
            });
        }
        var trackRow, _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    trackRow = table.querySelector('.track-row');
                    if (trackRow instanceof HTMLTableRowElement) {
                        playlistId = Number(trackRow.dataset.itemid);
                    }
                    _a = appendDividers;
                    _b = [table];
                    return [4 /*yield*/, fetchDividers(playlistId)];
                case 1: return [4 /*yield*/, _a.apply(void 0, _b.concat([_c.sent()]))];
                case 2:
                    _c.sent();
                    createTbodyMutationObserver(table);
                    table.addEventListener('mousedown', mousedown);
                    return [2 /*return*/];
            }
        });
    });
}
exports.initTableWithDivider = initTableWithDivider;
function createContextMenu(divider) {
    var dividerId = Number(divider.dataset.id);
    var menu = document.createElement('div');
    menu.classList.add('context-menu', 'hidden');
    var list = document.createElement('ul');
    list.classList.add('headers-menu__list');
    var deleteDividerButton = document.createElement('button');
    deleteDividerButton.innerText = 'Delete';
    deleteDividerButton.addEventListener('click', function () { return deleteDivider(dividerId); });
    var deleteDividerItem = document.createElement('li');
    deleteDividerItem.classList.add('context_menu_item');
    deleteDividerItem.appendChild(deleteDividerButton);
    var colorItem = document.createElement('li');
    var colorsList = document.createElement('ul');
    colorsList.classList.add('menu_colors_list');
    var _loop_1 = function (color) {
        var elem = document.createElement('li');
        elem.classList.add("bg-".concat(color), 'context_menu_item__color');
        elem.addEventListener('click', function () { menu.classList.add('hidden'); updateDividerColor(divider, color); });
        colorsList.appendChild(elem);
    };
    for (var _i = 0, dividerColors_1 = dividerColors; _i < dividerColors_1.length; _i++) {
        var color = dividerColors_1[_i];
        _loop_1(color);
    }
    colorItem.appendChild(colorsList);
    list.appendChild(deleteDividerItem);
    list.appendChild(colorItem);
    menu.append(list);
    divider.firstChild.parentElement.insertBefore(menu, divider.firstChild);
    divider.addEventListener('contextmenu', function (e) { return showContextMenu(e, divider); });
}
function showContextMenu(e, divider) {
    e.preventDefault();
    var menu = divider.querySelector('.context-menu');
    menu.style.left = "".concat(e.clientX, "px");
    menu.classList.remove('hidden');
    var documentClickHandler = function (e) {
        if (e.target instanceof HTMLElement) {
            var isClickedOutside = !menu.contains(e.target);
            if (isClickedOutside) {
                menu.classList.add('hidden');
                document.removeEventListener('click', documentClickHandler);
            }
        }
    };
    document.addEventListener('click', documentClickHandler);
}
function appendDividers(table, dividers) {
    return __awaiter(this, void 0, void 0, function () {
        var _i, dividers_1, divider, dividerRow, dividerCell, tbody;
        return __generator(this, function (_a) {
            for (_i = 0, dividers_1 = dividers; _i < dividers_1.length; _i++) {
                divider = dividers_1[_i];
                dividerRow = document.createElement('tr');
                dividerRow.classList.add('rows-divider');
                dividerCell = document.createElement('td');
                if (divider.color) {
                    dividerCell.classList.add("bg-".concat(divider.color));
                }
                dividerRow.appendChild(dividerCell);
                dividerRow.dataset.id = String(divider.id);
                dividerRow.dataset.position = String(divider.position);
                dividerRow.dataset.color = divider.color;
                tbody = table.querySelector('tbody');
                tbody.insertBefore(dividerRow, tbody.querySelectorAll('tr:not(.rows-divider)')[divider.position]);
                createContextMenu(dividerRow);
            }
            appendEmptyDivider(table);
            return [2 /*return*/];
        });
    });
}
function appendEmptyDivider(table) {
    var dividerRow = document.createElement('tr');
    dividerRow.classList.add('rows-divider');
    var dividerCell = document.createElement('td');
    dividerRow.appendChild(dividerCell);
    var tbody = table.querySelector('tbody');
    tbody.insertBefore(dividerRow, tbody.querySelectorAll('tr:not(.rows-divider)')[0]);
}
function fetchDividers(playlistId) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api_1.Api.getPlaylistDividers(playlistId)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function createDivider(dividerRow) {
    return __awaiter(this, void 0, void 0, function () {
        var divider, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, api_1.Api.createDivider(playlistId, getDividerNewPosition(dividerRow))];
                case 1:
                    divider = _a.sent();
                    dividerRow.dataset.id = divider.id;
                    dividerRow.dataset.position = divider.position;
                    createContextMenu(dividerRow);
                    appendEmptyDivider(dividerRow.closest('table'));
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    alertifyjs.error('Failed create divider');
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}
function updateDividerPosition(dividerRow) {
    return __awaiter(this, void 0, void 0, function () {
        var newPosition;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    newPosition = getDividerNewPosition(dividerRow);
                    dividerRow.dataset.position = String(newPosition);
                    return [4 /*yield*/, api_1.Api.updateDivider(dividerRow.dataset.id, [{ 'position': newPosition }])];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
function updateDividerColor(dividerRow, color) {
    return __awaiter(this, void 0, void 0, function () {
        var dividerCell;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api_1.Api.updateDivider(dividerRow.dataset.id, [{ 'color': color }])];
                case 1:
                    _a.sent();
                    dividerCell = dividerRow.querySelector("td");
                    dividerCell.classList.add("bg-".concat(color));
                    dividerCell.classList.replace("bg-".concat(dividerRow.dataset.color), "bg-".concat(color));
                    dividerRow.dataset.color = color;
                    return [2 /*return*/];
            }
        });
    });
}
function getDividerNewPosition(dividerRow) {
    var dividerId = dividerRow.dataset.id;
    var tableRows = dividerRow.closest('table')
        .querySelectorAll("tr:not(.rows-divider), ".concat(dividerId ? ".rows-divider[data-id=\"".concat(dividerId, "\"]") : '.rows-divider:not([data-id])'));
    return Array.from(tableRows)
        .findIndex(function (row) { return dividerId ?
        (row.dataset.id && row.dataset.id === dividerId) :
        (row.classList.contains('rows-divider') && !row.dataset.hasOwnProperty('id')); }) - 1;
}
function deleteDivider(dividerId) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    (_a = document.querySelector(".rows-divider[data-id=\"".concat(dividerId, "\"]"))) === null || _a === void 0 ? void 0 : _a.remove();
                    return [4 /*yield*/, api_1.Api.deleteDivider(dividerId)];
                case 1:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    });
}
function refreshDividers(e) {
    var dividers = document.querySelectorAll('.rows-divider[data-id]');
    var tableRows = dividers[0].closest('tbody').querySelectorAll('tr:not(.rows-divider)');
    dividers.forEach(function (divider) {
        divider.closest('tbody').insertBefore(divider, tableRows[Number(divider.dataset.position)]);
    });
}
function createTbodyMutationObserver(table) {
    var callback = function () {
        document.addEventListener('mouseup', refreshDividers, { once: true });
    };
    var observer = new MutationObserver(callback);
    var tbody = table.querySelector('tbody');
    var config = { attributes: true, childList: false };
    observer.observe(tbody, config);
}
